import { render } from "./ReportBuilder.vue?vue&type=template&id=9fc76ac8"
import script from "./ReportBuilder.vue?vue&type=script&lang=js"
export * from "./ReportBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/insights/report-building/ReportBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9fc76ac8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9fc76ac8', __exports__)) {
    api.reload('9fc76ac8', __exports__)
  }
  
  module.hot.accept("./ReportBuilder.vue?vue&type=template&id=9fc76ac8", () => {
    api.rerender('9fc76ac8', render)
  })

}


export default __exports__